module.exports = __webpack_public_path__ + "img/antes_despues_31.4cd98a58.png";